import moment from 'moment'

const admin = {
  namespaced: true,
  state: {
    isLoadingStats: false,
    appStatistics: {
      isLoaded: false,
      started: 0,
      completed: 0,
      teamLeader: 0
    },
    filteredApps: [],
    appPagination: {
      total: 0,
      limit: 20,
      pages: 1,
      page: 1
    },
    activeApp: {
      firstName: '',
      lastName: '',
      email: '',
      svId: '',
      username: '',
      data: {
        expectedGraduationMonth: '01',
        expectedGraduationYear: '2024',
        yearsVolunteered: [],
        yearsVolunteeredAsia: [],
        proofOfEnrollment: {
          type: ''
        }
      },
      proofOfEnrollmentUrl: '',
      completed: false,
      teamLeader: false,
      financialAid: false,
      isLoaded: false
    },
    exportData: {
      progress: 0,
      total: 1,
      cancelDownload: false
    }
  },
  mutations: {
    loadingStats (state) {
      state.isLoadingStats = true
    },
    setAppStatistics (state, { total, completed, team_leader }) {
      state.isLoadingStats = false
      state.appStatistics.isLoaded = true
      state.appStatistics.started = total
      state.appStatistics.completed = completed
      state.appStatistics.teamLeader = team_leader // eslint-disable-line camelcase
    },
    setFilteredApps (state, apps) {
      state.filteredApps = apps
    },
    setPagination (state, { limit, pages, page, total }) {
      state.appPagination.total = total
      state.appPagination.limit = limit
      state.appPagination.pages = pages
      state.appPagination.page = page
    },
    loadApp (state, data) {
      data.isLoaded = true
      state.activeApp = { ...data }
    },
    loadProofOfEnrollment (state, url) {
      state.activeApp.proofOfEnrollmentUrl = url
    },
    deactivateApp (state) {
      state.activeApp = {
        firstName: '',
        lastName: '',
        email: '',
        svId: '',
        username: '',
        data: {
          expectedGraduationMonth: '01',
          expectedGraduationYear: '2018',
          yearsVolunteered: [],
          yearsVolunteeredAsia: [],
          proofOfEnrollment: {
            type: ''
          }
        },
        proofOfEnrollmentUrl: '',
        completed: false,
        teamLeader: false,
        financialAid: false,
        isLoaded: false
      }
    },
    cancelDownload (state) {
      state.exportData.cancelDownload = true
    },
    setExportData (state, { total, addProgress }) {
      state.exportData.total = total
      if (state.exportData.progress + addProgress > total) {
        state.exportData.progress = total
      } else {
        state.exportData.progress += addProgress
      }
    },
    resetExportData (state) {
      state.exportData.total = 0
      state.exportData.progress = 0
    },
    updateProcessingStatus (state, value) {
      state.activeApp.statusId = value
    }
  },
  getters: {
    appFullName: (state) => {
      return state.activeApp.firstName + ' ' + state.activeApp.lastName
    },
    appExpectedGraduation: (state) => {
      return moment(state.activeApp.data.expectedGraduationMonth + '-01-' + state.activeApp.data.expectedGraduationYear).format('MMMM YYYY')
    },
    appYearsVolunteered: (state) => {
      return state.activeApp.data.yearsVolunteered.join(', ')
    },
    appYearsVolunteeredAsia: (state) => {
      if (state.activeApp.data.hasOwnProperty('yearsVolunteeredAsia')) {
        return state.activeApp.data.yearsVolunteeredAsia.join(', ')
      } else {
        return ''
      }
    },
    appFinancialAidAndFlying: (state) => {
      return state.activeApp.data.financialAid && state.activeApp.data.primaryTransport === 'plane'
    },
    appProofOfEnrollmentIsLoaded: (state) => {
      return state.activeApp.proofOfEnrollmentUrl !== ''
    },
    appProofOfEnrollmentIsImage: (state) => {
      return state.activeApp.data.proofOfEnrollment.type.split('/')[0] === 'image'
    },
    appProofOfEnrollmentIsPDF: (state) => {
      return state.activeApp.data.proofOfEnrollment.type === 'application/pdf'
    }
  },
  actions: {
    getAppStatistics ({ commit, rootState }) {
      commit('loadingStats')
      fetch(process.env.BASE_URL + 'application/statistics',
        {
          headers: {
            'Authorization': rootState.user.session.accessToken.jwtToken
          }
        }).then(response => {
          response.json().then(payload => {
            commit('setAppStatistics', payload.data)
          })
        })
    },
    searchApplications ({ commit, rootState }, filterData) {
      return new Promise((resolve, reject) => {
        fetch(process.env.BASE_URL + 'application/search', {
          method: 'POST',
          headers: {
            'Authorization': rootState.user.session.accessToken.jwtToken
          },
          body: JSON.stringify(filterData)
        }).then(response => {
          response.json().then(payload => {
            if (response.statusCode === 500) {
              commit('error', { message: payload.data.message }, { root: true })
              reject(payload.data.error)
            } else {
              let apps = payload.data.applications.map(app => {
                let attributes = {}
                app.sv.Attributes.forEach(attr => {
                  attributes[attr.Name] = attr.Value
                })
                return {
                  firstName: attributes.given_name,
                  lastName: attributes.family_name,
                  email: attributes.email,
                  svId: attributes['custom:svid'],
                  completed: app.completed,
                  teamLeader: app.team_leader,
                  financialAid: app.financial_aid,
                  username: app.sv.Username
                }
              })
              commit('setFilteredApps', apps)
              resolve()
            }
          })
        }).catch(err => {
          commit('error', { message: err.message }, { root: true })
          reject(err)
        })
      })
    },
    sendFilterByStatusRequest ({ commit, state, rootState }, { queryString, checkCancel, returnArray, withData, withScores }) {
      return new Promise((resolve, reject) => {
        if (checkCancel && state.exportData.cancelDownload) {
          resolve({
            canceled: true
          })
        } else {
          fetch(process.env.BASE_URL + 'application/search' + queryString,
            {
              headers: {
                'Authorization': rootState.user.session.accessToken.jwtToken
              }
            }).then(response => {
              response.json().then(payload => {
                if (response.statusCode === 500) {
                  commit('error', { message: payload.data.message }, { root: true })
                  reject(payload.data.error)
                } else {
                  let apps = payload.data.apps.map(app => {
                    let attributes = {
                      given_name: 'N/A',
                      family_name: 'N/A',
                      email: 'N/A',
                      'custom:svid': 'N/A'
                    }
                    let username = app.sv_id
                    if (app.sv !== undefined) {
                      app.sv.UserAttributes.forEach(attr => {
                        attributes[attr.Name] = attr.Value
                      })
                      username = app.sv.Username
                    }
                    if (returnArray) {
                      let appReturn = [
                        attributes.given_name,
                        attributes.family_name,
                        attributes.email,
                        attributes['custom:svid'],
                        app.completed,
                        app.team_leader,
                        app.financial_aid,
                        username
                      ]
                      if (withData) {
                        appReturn.push(app.data)
                      }
                      if (withScores) {
                        appReturn.push(app.totalavg)
                      }
                      return appReturn
                    } else {
                      return {
                        firstName: attributes.given_name,
                        lastName: attributes.family_name,
                        email: attributes.email,
                        svId: attributes['custom:svid'],
                        completed: app.completed,
                        teamLeader: app.team_leader,
                        financialAid: app.financial_aid,
                        username: username
                      }
                    }
                  })
                  resolve({
                    apps: apps,
                    total: parseInt(payload.data.total),
                    limit: payload.data.limit,
                    pages: payload.data.pages,
                    page: payload.data.page,
                    canceled: false
                  })
                }
              })
            })
        }
      })
    },
    filterApps ({ commit, dispatch, rootState }, filters) {
      return new Promise((resolve, reject) => {
        let queryParams = []
        if (filters.filterCompleted) {
          let completedValue = filters.completed ? 'true' : 'false'
          queryParams.push('completed=' + completedValue)
        }
        if (filters.filterTeamLeader) {
          let teamLeaderValue = filters.teamLeader ? 'true' : 'false'
          queryParams.push('teamLeader=' + teamLeaderValue)
        }
        if (filters.filterFinancialAid) {
          let financialAidValue = filters.financialAid ? 'true' : 'false'
          queryParams.push('financialAid=' + financialAidValue)
        }
        if (filters.page > 1) {
          queryParams.push('page=' + filters.page.toString())
        }
        let queryString = '?' + queryParams.join('&')
        dispatch('sendFilterByStatusRequest', {
          queryString: queryString,
          checkCancel: false,
          returnArray: false,
          withData: false
        }).then(responseData => {
          commit('setFilteredApps', responseData.apps)
          commit('setPagination', {
            total: responseData.total,
            limit: responseData.limit,
            pages: responseData.pages,
            page: responseData.page
          })
          resolve()
        })
      })
    },
    exportApps ({ commit, dispatch, rootState }, filters) {
      return new Promise((resolve, reject) => {
        let queryParams = []
        if (filters.filterCompleted) {
          let completedValue = filters.completed ? 'true' : 'false'
          queryParams.push('completed=' + completedValue)
        }
        if (filters.filterTeamLeader) {
          let teamLeaderValue = filters.teamLeader ? 'true' : 'false'
          queryParams.push('teamLeader=' + teamLeaderValue)
        }
        if (filters.filterFinancialAid) {
          let financialAidValue = filters.financialAid ? 'true' : 'false'
          queryParams.push('financialAid=' + financialAidValue)
        }
        if (filters.withData) {
          queryParams.push('withData=true')
          // Data can contain cause the body to be too long. Decrease the default limit
          queryParams.push('limit=10')
        }
        if (filters.withScores) {
          queryParams.push('withScores=true')
        }
        let queryString = '?' + queryParams.join('&')
        dispatch('sendFilterByStatusRequest', {
          queryString: queryString,
          checkCancel: true,
          returnArray: true,
          withData: filters.withData,
          withScores: filters.withScores
        }).then(responseData => {
          if (responseData.canceled) {
            commit('resetExportData')
          } else {
            commit('setExportData', {
              addProgress: responseData.total < responseData.limit ? responseData.total : responseData.limit,
              total: responseData.total
            })
            let apps = responseData.apps
            let download = require('downloadjs')
            if (responseData.pages > 1) {
              let asyncLoop = (o) => {
                let loop = (page, cancelDownload) => {
                  if (cancelDownload) {
                    // Check to see if the user canceled the export
                    commit('resetExportData')
                    resolve()
                    return
                  }
                  if (page === false) {
                    o.callback()
                    return
                  }
                  o.functionToLoop(loop, page)
                }
                loop(2) // init
              }
              let pageParameter = 'page='
              if (queryParams.length > 0) {
                pageParameter = '&' + pageParameter
              }
              let nextPageRequest = (nextPage) => {
                return new Promise((resolve, reject) => {
                  dispatch('sendFilterByStatusRequest', {
                    queryString: queryString + pageParameter + nextPage.toString(),
                    checkCancel: true,
                    returnArray: true,
                    withData: filters.withData,
                    withScores: filters.withScores
                  }).then(nextResponseData => {
                    if (!nextResponseData.canceled) {
                      commit('setExportData', {
                        addProgress: nextResponseData.total < nextResponseData.limit ? nextResponseData.total : nextResponseData.limit,
                        total: nextResponseData.total
                      })
                    }
                    resolve(nextResponseData)
                  })
                })
              }
              // Use an asynchronous loop to go through each page
              asyncLoop({
                functionToLoop: (loop, page) => {
                  nextPageRequest(page).then(nextApps => {
                    if (!nextApps.canceled) {
                      apps = apps.concat(nextApps.apps)
                    }
                    if (responseData.pages > page) {
                      loop(page + 1, nextApps.canceled)
                    } else {
                      loop(false, nextApps.canceled)
                    }
                  })
                },
                callback: () => {
                  // apps is now a full array of results
                  // convert array to CSV
                  let csv = "First Name,Last Name,Email,SV ID,Completed,Team Leader,Financial Aid,Username" // eslint-disable-line quotes
                  if (filters.withData) {
                    // Use the keys from the application to populate the CSV
                    csv += ','
                    let dataKeys = []
                    Object.keys(rootState.application.data).forEach(key => {
                      if (key !== 'proofOfEnrollment' && key !== 'step' && key !== 'acceptedTerms') {
                        dataKeys.push(key)
                      }
                    })
                    csv += dataKeys.join()
                    if (filters.withScores) {
                      csv += ",Average Essay Score" // eslint-disable-line quotes
                      apps.sort((a, b) => {
                        if (a[9] < b[9]) {
                          return 1
                        }
                        if (a[9] > b[9]) {
                          return -1
                        }
                        return 0
                      })
                    }
                    csv += "\n" // eslint-disable-line quotes
                    apps.forEach(app => {
                      let score = ''
                      if (filters.withScores) {
                        score = app.pop() // eslint-disable-line no-unused-vars
                      }
                      let appData = app.pop()
                      csv += app.join() + ','
                      let formatAppData = []
                      dataKeys.forEach(keyName => {
                        switch (typeof appData[keyName]) {
                          case 'string':
                            // Replace double quotes with single quotes and new lines with spaces
                            let value = appData[keyName].replace(/"/g, '\'').replace(/\n/g, '  ')
                            formatAppData.push('"' + value + '"')
                            break
                          case 'boolean':
                            formatAppData.push('"' + appData[keyName] + '"')
                            break
                          case 'object':
                            formatAppData.push('"' + appData[keyName].join() + '"')
                            break
                          case 'undefined':
                            formatAppData.push('""')
                        }
                      })
                      csv += formatAppData.join()
                      if (filters.withScores) {
                        csv += "," + score  // eslint-disable-line no-undef, quotes
                      }
                      csv += "\n" // eslint-disable-line quotes
                    })
                  } else {
                    if (filters.withScores) {
                      csv += ",Average Essay Score" // eslint-disable-line quotes
                      apps.sort((a, b) => {
                        if (a[8] < b[8]) {
                          return 1
                        }
                        if (a[8] > b[8]) {
                          return -1
                        }
                        return 0
                      })
                    }
                    csv += "\n" // eslint-disable-line quotes
                    apps.forEach(app => {
                      csv += app.join() + "\n" // eslint-disable-line quotes
                    })
                  }
                  download(csv, 'filtered-sv-apps.csv', 'text/csv')
                  resolve()
                  commit('resetExportData')
                }
              })
            } else {
              // Only one page to begin with so convert to csv
              let csv = "First Name,Last Name,Email,SV ID,Completed,Team Leader,Financial Aid,Username" // eslint-disable-line quotes
              if (filters.withData) {
                // Use the keys from the application to populate the CSV
                csv += ','
                let dataKeys = []
                Object.keys(rootState.application.data).forEach(key => {
                  if (key !== 'proofOfEnrollment' && key !== 'step' && key !== 'acceptedTerms') {
                    dataKeys.push(key)
                  }
                })
                csv += dataKeys.join()
                if (filters.withScores) {
                  csv += ",Average Essay Score" // eslint-disable-line quotes
                  apps.sort((a, b) => {
                    if (a[9] < b[9]) {
                      return 1
                    }
                    if (a[9] > b[9]) {
                      return -1
                    }
                    return 0
                  })
                }
                csv += "\n" // eslint-disable-line quotes
                apps.forEach(app => {
                  if (filters.withScores) {
                    let score = app.pop() // eslint-disable-line no-unused-vars
                  }
                  let appData = app.pop()
                  csv += app.join() + ','
                  let formatAppData = []
                  dataKeys.forEach(keyName => {
                    switch (typeof appData[keyName]) {
                      case 'string':
                      case 'boolean':
                        formatAppData.push('"' + appData[keyName] + '"')
                        break
                      case 'object':
                        formatAppData.push('"' + appData[keyName].join() + '"')
                        break
                      case 'undefined':
                        formatAppData.push('""')
                    }
                  })
                  csv += formatAppData.join()
                  if (filters.withScores) {
                    csv += "," + score  // eslint-disable-line no-undef, quotes
                  }
                  csv += "\n" // eslint-disable-line quotes
                })
              } else {
                if (filters.withScores) {
                  csv += ",Average Essay Score" // eslint-disable-line quotes
                  apps.sort((a, b) => {
                    if (a[8] < b[8]) {
                      return 1
                    }
                    if (a[8] > b[8]) {
                      return -1
                    }
                    return 0
                  })
                }
                csv += "\n" // eslint-disable-line quotes
                apps.forEach(app => {
                  csv += app.join() + "\n" // eslint-disable-line quotes
                })
              }
              download(csv, 'filtered-sv-apps.csv', 'text/csv')
              resolve()
              commit('resetExportData')
            }
          }
        })
      })
    },
    getApp ({ commit, rootState }, username) {
      return new Promise((resolve, reject) => {
        fetch(process.env.BASE_URL + 'application/' + username,
          {
            headers: {
              'Authorization': rootState.user.session.accessToken.jwtToken
            }
          })
          .then(response => {
            response.json().then(payload => {
              if (response.status === 200 && payload.success) {
                let attributes = {}
                payload.data.sv.UserAttributes.forEach(attr => {
                  attributes[attr.Name] = attr.Value
                })
                let app = {
                  firstName: attributes.given_name,
                  lastName: attributes.family_name,
                  email: attributes.email,
                  svId: attributes['custom:svid'],
                  data: payload.data.data,
                  completed: payload.data.completed,
                  teamLeader: payload.data.team_leader,
                  financialAid: payload.data.financial_aid,
                  username: payload.data.sv.Username,
                  statusId: payload.data.status_id
                }
                commit('loadApp', app)
                // Get Proof of Enrollment URL
                fetch(process.env.BASE_URL + 'files/' + username,
                  {
                    headers: {
                      'Authorization': rootState.user.session.accessToken.jwtToken
                    }
                  })
                  .then(response => {
                    response.json().then(payload => {
                      if (response.status === 200 && payload.success) {
                        commit('loadProofOfEnrollment', payload.data)
                        resolve()
                      } else {
                        commit('error', { message: 'Unable to load application' }, { root: true })
                        resolve()
                      }
                    })
                  }).catch(err => {
                    commit('error', { message: err.message }, { root: true })
                    reject(err)
                  })
              } else if (response.status === 404 && !payload.success) {
                commit('appLoadedInit')
                resolve()
              } else {
                commit('error', { message: 'Unable to load application' }, { root: true })
                resolve()
              }
            })
          }).catch(err => {
            commit('error', { message: err.message }, { root: true })
            reject(err)
          })
      })
    },
    assignSVAppsToTLs ({ commit, rootState }, tlsPerApp) {
      return new Promise((resolve, reject) => {
        fetch(process.env.BASE_URL + 'jury/assign-jury',
          {
            method: 'POST',
            headers: {
              'Authorization': rootState.user.session.accessToken.jwtToken
            },
            body: JSON.stringify({TLsPerApp: tlsPerApp})
          })
          .then(response => {
            response.json().then(payload => {
              if (response.status === 200 && payload.success) {
                commit('message', { message: payload.data.message }, { root: true })
                resolve()
              } else {
                commit('error', { message: payload.data.message }, { root: true })
                reject(payload.data.error)
              }
            })
          }).catch(err => {
            commit('error', { message: err.message }, { root: true })
            reject(err)
          })
      })
    },
    updateProcessingStatus ({ commit, state, rootState }) {
      return new Promise((resolve, reject) => {
        fetch(process.env.BASE_URL + 'application/status/' + state.activeApp.username,
          {
            method: 'POST',
            headers: {
              'Authorization': rootState.user.session.accessToken.jwtToken
            },
            body: JSON.stringify({statusId: state.activeApp.statusId})
          })
          .then(response => {
            response.json().then(payload => {
              if (response.status === 200 && payload.success) {
                commit('message', { message: 'Updated application status' }, { root: true })
                resolve()
              } else {
                commit('error', { message: payload.data.message }, { root: true })
                reject(payload.data.error)
              }
            })
          }).catch(err => {
            commit('error', { message: err.message }, { root: true })
            reject(err)
          })
      })
    }
  }
}

export default admin



// WEBPACK FOOTER //
// ./src/store/admin.js